import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Interiors from "@/pages/interiors/page";
import Exteriors from "@/pages/exteriors/page";
import CreationsSurMesure from "@/pages/creations-sur-mesure/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import MentionsLegales from "@/pages/mentions-legales/page";
import PolitiqueConfidentialite from "@/pages/politique-confidentialite/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/interiors",
    element: <Interiors />,
  },
  {
    path: "/exteriors",
    element: <Exteriors />,
  },
  {
    path: "/creations-sur-mesure",
    element: <CreationsSurMesure />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;